import type { FaireProductEntity } from "../../entity_types/product";

export const p_tuhpkhy4v5: FaireProductEntity = {
  token: "p_tuhpkhy4v5",
  type: "product",
  name: "Local New England Foods - Art Print - Fluff & More",
  brandToken: "b_2nlyab4cca",
  brandName: "Sarah Wormann Art",
  imageUrl: "https://cdn.faire.com/fastly/8fb668a6cef7d59ad029a0123ad6786dda9e3247fe309cea77eb898f7fd08e01.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d28fcfada4034a7b84035051cf5dc253684c52442c959924e48a74489de17c6d.jpeg",
    "https://cdn.faire.com/fastly/7bfb7352bbbb6e72aa8ab32306f522b84e7c17a9b815a77be2924f7affe3f5fc.jpeg",
    "https://cdn.faire.com/fastly/f5ff984fd83b7880aa72e11994c241cd4fe2f60f9092dabe294e3780e285ae32.jpeg",
    "https://cdn.faire.com/fastly/8d6965b3268e741a25f289ffac8cf10e14a1689bbafed2aaae7a1ec4bd1b133c.jpeg",
    "https://cdn.faire.com/fastly/d6054974670a5ae129f2031a8f8132ee498820b8bcd5b879c7340cab55a293e1.jpeg",
    "https://cdn.faire.com/fastly/6ebdfe2627a7ef2b2c86fe619bf00bbd0928218be7e47dfafc33049fdaf1ad35.jpeg",
    "https://cdn.faire.com/fastly/1aa96f8417eb8333c8fb6c762ecf3e237088d8df468df0d3e4b3df9a215c925c.jpeg"
  ],
  priceDollars: 10,
  description: "A comprehensive celebration of 51 iconic New England foods, from regional favorites to beloved local brands in one collection! Features items like Fluff, Moxie, Teddie peanut butter, and many other local specialties.\n\nAll art prints are painted, printed, and packaged by Sarah in her home studio in Boston, MA.\n\n\n𝐏𝐫𝐢𝐧𝐭 𝐝𝐞𝐭𝐚𝐢𝐥𝐬:\n• Printed on archival paper using pigment inks for crisp details and vibrant colors that will last years and years\n• Hand-signed in pencil\n\n𝐒𝐢𝐳𝐞𝐬:\n• Available sizes: 5”x7”, 8”x10”, 11”x14”\n• Print sizes fit standard frames\n\n𝐏𝐚𝐜𝐤𝐚𝐠𝐢𝐧𝐠 𝐚𝐧𝐝 𝐬𝐡𝐢𝐩𝐩𝐢𝐧𝐠:\n• Each print is packaged in a clear sleeve with cardboard backing, ready to display\n• Orders are shipped in a rigid mailer or cardboard box\n• All prints are unframed",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:03:53.036Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
